export default "__VITE_ASSET__Cv52Ze8D__"